import * as borogove from "borogove";
import { createContext, useContext } from "react";
import { useOutletContext } from "react-router";
import {
	FormLabel,
	FormControl,
	RadioGroup,
	Radio,
	Switch,
	FormControlLabel,
} from "@mui/material";

export type SettingsData = {
	enterIsSend: boolean;
	richTextToolbar: boolean;
	audibleNotifications: boolean;
	messageRequests: "invites" | "spam" | "strangers";
};
export const SettingsContext = createContext<SettingsData>({
	enterIsSend: true,
	richTextToolbar: false,
	audibleNotifications: false,
	messageRequests: "spam",
});

export const Settings = () => {
	const { persistence, setSettings } = useOutletContext<{
		persistence: borogove.persistence.KeyValueStore;
		setSettings: (x: SettingsData) => void;
	}>();
	const settings = useContext(SettingsContext);
	const {
		audibleNotifications,
		enterIsSend,
		richTextToolbar,
		messageRequests,
	} = settings;

	return (
		<section>
			<h1>Settings</h1>
			<FormControlLabel
				control={
					<Switch
						checked={enterIsSend}
						onChange={(e) => {
							persistence.set(
								"config#enterIsSend",
								e.target.checked ? "true" : "false",
							);
							setSettings({ ...settings, enterIsSend: e.target.checked });
						}}
					/>
				}
				label="Enter is Send"
			/>

			<FormControlLabel
				control={
					<Switch
						checked={richTextToolbar}
						onChange={(e) => {
							persistence.set(
								"config#richTextToolbar",
								e.target.checked ? "true" : "false",
							);
							setSettings({ ...settings, richTextToolbar: e.target.checked });
						}}
					/>
				}
				label="Formatting toolbar"
			/>

			<FormControlLabel
				control={
					<Switch
						checked={audibleNotifications}
						onChange={(e) => {
							persistence.set(
								"config#audibleNotifications",
								e.target.checked ? "true" : "false",
							);
							setSettings({
								...settings,
								audibleNotifications: e.target.checked,
							});
						}}
					/>
				}
				label="Audible notifications"
			/>

			<FormControl>
				<FormLabel>Hide chats in Message Requests area</FormLabel>
				<RadioGroup
					value={messageRequests}
					onChange={(e) => {
						persistence.set("config#messageRequests", e.target.value);
						setSettings({
							...settings,
							messageRequests: e.target.value as
								| "invites"
								| "spam"
								| "strangers",
						});
					}}
				>
					<FormControlLabel
						value="invites"
						control={<Radio />}
						label="Invites Only"
					/>
					<FormControlLabel
						value="spam"
						control={<Radio />}
						label="Invites & Suspected SPAM"
					/>
					<FormControlLabel
						value="strangers"
						control={<Radio />}
						label="Messages from Strangers"
					/>
				</RadioGroup>
			</FormControl>
		</section>
	);
};
